import { Link } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div>
              <Link to="/" className="text-xl font-bold font-heading text-background-50 whitespace-nowrap cursor-pointer">
                {siteInfo.logo}
              </Link>
              <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
                {siteInfo.description}
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                快速导航
              </h4>
              <ul className="space-y-2.5">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                安全提示
              </h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                请认准 https www kaiyun com 官方入口，谨防仿冒网站。建议将官方网址添加至浏览器收藏夹，每次从收藏夹打开以确保访问的是真实官方网站。
              </p>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} {siteInfo.name} 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors whitespace-nowrap" rel="nofollow">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}